export const deAuth = () => {
  return {
    type: "DEAUTH",
    payload: false
  };
};
export const auth = () => {
  return {
    type: "AUTH",
    payload: true
  };
};



// WEBPACK FOOTER //
// ./src/actions/index.js